import { Component, Input, OnInit } from '@angular/core';
import { RestaurantProfile } from '../../../models/List.Restaurant';

@Component({
  selector: 'app-numbers',
  templateUrl: './numbers.component.html'
})
export class NumbersComponent implements OnInit {
  @Input() restaurantProfile?: RestaurantProfile;
  constructor() { }

  ngOnInit(): void {
  }

}
